(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bunnings-product-tile"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__bunningsInitNewProductTilesInit) return;
    window.__bunningsInitNewProductTilesInit = true;

    const TILE_ROOT = '.bunnings-product-tile';

    const syncIndicatorDots = (track) => {
      const tile = track.closest(TILE_ROOT);
      if (!tile) return;
      const dots = tile.querySelectorAll('[data-new-product-tile-indicator-dot]');
      const slides = track.querySelectorAll('[data-new-product-tile-media-slide]');
      if (!dots.length || !slides.length) return;

      const slideWidth = track.clientWidth || 1;
      const index = Math.round(track.scrollLeft / slideWidth);
      const clamped = Math.max(0, Math.min(index, dots.length - 1));

      dots.forEach((dot, i) => {
        const isActive = i === clamped;
        dot.classList.toggle('bunnings-product-tile__indicator-dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const initMediaTracks = (root = document) => {
      root.querySelectorAll('[data-new-product-tile-media-track]').forEach((track) => {
        if (!(track instanceof HTMLElement)) return;
        if (track.dataset.newProductTileMediaInit === 'true') return;
        track.dataset.newProductTileMediaInit = 'true';

        track.addEventListener('scroll', () => syncIndicatorDots(track), { passive: true });

        const tile = track.closest(TILE_ROOT);
        tile?.querySelectorAll('[data-new-product-tile-indicator-dot]').forEach((dot) => {
          dot.addEventListener('click', () => {
            if (!(dot instanceof HTMLButtonElement)) return;
            const index = Number.parseInt(dot.dataset.mediaIndex || '0', 10);
            const slideWidth = track.clientWidth || 0;
            track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
          });
        });
      });
    };

    const initNewProductTiles = (root = document) => {
      initMediaTracks(root);
    };

    // Tiles can be appended after load (infinite-scroll pagination via
    // paginated-list.js, AJAX facet updates, etc.). A document-level observer
    // re-runs init on newly inserted tiles; initMediaTracks is idempotent
    // (guarded by data-new-product-tile-media-init), so re-entry is cheap.
    const observeAppendedTiles = () => {
      if (!('MutationObserver' in window) || !document.body) return;

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            if (node.matches(TILE_ROOT) || node.querySelector(TILE_ROOT)) {
              initNewProductTiles(node);
            }
          });
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    };

    window.__bunningsInitNewProductTiles = initNewProductTiles;

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initNewProductTiles(document);
          observeAppendedTiles();
        },
        { once: true }
      );
    } else {
      initNewProductTiles(document);
      observeAppendedTiles();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
